import { useSelector } from 'react-redux'
import config from 'config'

import { getLocaleSelector, getMpvid } from 'client/store/config'
import { queryRatings } from 'client/queries/queryRatings'
import { useQuery } from '@tanstack/react-query'

export const useRatingsAndReviews = (mpv?: string) => {
  const locale = useSelector(getLocaleSelector)
  const mpvId = useSelector(getMpvid)

  const { data: ratingsData } = useQuery(
    queryRatings(locale, mpv || mpvId, {
      enabled: !!config.tenant && !!locale && (!!mpvId || !!mpv),
      staleTime: Infinity,
      retry: false,
    }),
  )

  return ratingsData
}
